module.exports = __webpack_public_path__ + "static/media/OrdersAndCart.3c62e1b6.png";